import { Injectable } from '@angular/core';
import { ServicioInteropereabilidadRequestService } from './servicio-interopereabilidad-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioInteropereabilidadService {
  constructor(private requestUrl: ServicioInteropereabilidadRequestService) { }

  private buildPayload(codigoBaseDatos: string, uncoSede: string, numeroDocumento: string = '', tipoDocumento: string = '') {
    const body: Body = {
      resourceType: 'Parameters',
      parameter: [
        {
          name: 'identifier',
          part: [
            {
              name: 'type',
              valueString: tipoDocumento || ''
            },
            {
              name: 'value',
              valueString: numeroDocumento || ''
            }
          ]
        }
      ]
    };

    return {
      codigoBaseDatos,
      parametrosFiltros: {
        uncoSede
      },
      body
    };
  }

  public getEventos(codigoBaseDatos: string, uncoSede: string, numeroDocumento: string = '', tipoDocumento: string = '') {
    return this.requestUrl.getRequest(
      'integracion-hc/consult-patient',
      this.buildPayload(codigoBaseDatos, uncoSede, numeroDocumento, tipoDocumento)
    );
  }

  getConsultarRdaPaciente(codigoBaseDatos: string, uncoSede: string, numeroDocumento: string = '', tipoDocumento: string = '') {
    return this.requestUrl.getRequest(
      'integracion-hc/rda-v2',
      this.buildPayload(codigoBaseDatos, uncoSede, numeroDocumento, tipoDocumento)
    );
  }

  getEncuentrosClinicos(codigoBaseDatos: string, uncoSede: string, numeroDocumento: string = '', tipoDocumento: string = '') {
    return this.requestUrl.getRequest(
      'integracion-hc/rda-v3',
      this.buildPayload(codigoBaseDatos, uncoSede, numeroDocumento, tipoDocumento)
    );
  }

  getConsultarRdaByCompositionID(codigoBaseDatos: string, uncoSede: string, compositionId: string = '') {
    const payload = {
      codigoBaseDatos,
      parametrosFiltros: {
        uncoSede,
        compositionId
      }
    };

    return this.requestUrl.getRequest(
      'integracion-hc/consult-rda-por-id-composition', payload
    );
  }

  getDocumentResourceByDocumentId(codigoBaseDatos: string, uncoSede: string, attachmentUrl: string = '') {
    const payload = {
      codigoBaseDatos,
      parametrosFiltros: {
        uncoSede,
        attachmentUrl
      }
    };

    return this.requestUrl.getRequest(
      'integracion-hc/consult-document-reference', payload
    );
  }
}

interface ParametrosIntegracionEntity {
  codigoBaseDatos: string;
  uncoSede: string;
  body: Body;
}

interface Body {
  resourceType: string;
  parameter: Parameter[];
}

interface Parameter {
  name: string;
  part: Part[];
}

interface Part {
  name: string;
  valueString: string;
}